export const PUBLIC_HOST_RESERVED_PATHS = [
    "embed",
    "api",
    "s3-proxy",
    "sitemap.xml",
    "robots.txt",
    "_astro",
    "favicon.ico",
    "health",
];
